import type {
  OrganizationModel,
  OrganizationReportingModel,
  OrganizationSearchModel,
} from '../app/types/organization.type.ts';
import baseApi, { CacheTag } from './meeting-md-api-slice';

const organizationApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    fetchOrganizationSearch: builder.query<OrganizationSearchModel[], string>({
      query: params => {
        return params ? `Organization?${params}` : 'Organization';
      },
      providesTags: [CacheTag.AccountReps],
      keepUnusedDataFor: 300,
    }),
    fetchOrganization: builder.query<OrganizationModel, string>({
      query: key => ({ url: `organization/${key}` }),
      providesTags: [CacheTag.Organization],
    }),
    postOrganization: builder.mutation<OrganizationModel, OrganizationModel>({
      query: post => ({
        url: 'organization',
        method: 'POST',
        body: post,
      }),
      invalidatesTags: [CacheTag.Organization],
    }),
    putOrganization: builder.mutation<OrganizationModel, OrganizationModel>({
      query: put => ({
        url: 'organization',
        method: 'PUT',
        body: put,
      }),
      invalidatesTags: [CacheTag.Organization],
    }),
    fetchOrganizationReporting: builder.query<
      OrganizationReportingModel,
      { key: string; start: string; end: string }
    >({
      query: ({ key, start, end }) => `Organization/${key}/Reporting?start=${start}&end=${end}`,
    }),
  }),
});

export const {
  useFetchOrganizationQuery,
  useFetchOrganizationReportingQuery,
  usePostOrganizationMutation,
  usePutOrganizationMutation,
  useFetchOrganizationSearchQuery,
} = organizationApi;
